import React, { useState } from "react";
import { FormControl } from "react-bootstrap";

import { MultiSearchVariableSelectItem } from "./MultiSearchVariableSelectItem";
import { MultiSearchVariableTree } from "./MultiSearchVariableTree";
import { MULTISEARCH_USAGE } from "src/stores/MultiSearchStore/MultiSearchStore";
import { CustomTooltip } from "src/components/tooltip/CustomTooltip";

import "./MultiSearchVariableSelect.scss";

/**
 * @typedef {import("../../stores/MultiSearchStore/MultiSearchFormStore").MultiSearchFormStore} MultiSearchFormStore
 */

/**
 *
 * @param {{store: MultiSearchFormStore, loading: boolean}} props
 * @returns
 */
export const MultiSearchVariableSelect = ({ store, loading, usage }) => {
  const [searchExpression, setSearchExpression] = useState("");
  const [expandedVariables, setExpandedVariables] = useState([]);

  const changeSearch = (event) => {
    const value = event.target.value;
    setSearchExpression(() => value);
  };

  const filterVariablesBySearchExpression = (
    variableTreeModel,
    searchExpression
  ) => {
    const seLC = searchExpression.toLowerCase();
    const reduceVariables = (prevVariables, currentVariable) => {
      if (
        currentVariable.name?.toLowerCase().includes(seLC) ||
        currentVariable.code?.toLowerCase().includes(seLC) ||
        currentVariable.description?.toLowerCase().includes(seLC)
      ) {
        prevVariables.push(currentVariable);
        return prevVariables;
      }
      if (Array.isArray(currentVariable.nodes)) {
        const nodes = currentVariable.nodes.reduce(reduceVariables, []);
        if (nodes.length) prevVariables.push({ ...currentVariable, nodes });
      }
      return prevVariables;
    };
    return variableTreeModel.reduce(reduceVariables, []);
  };
  const options = filterVariablesBySearchExpression(
    store.optionsForSelectorUnselected,
    searchExpression
  );

  return (
    <div className="MultiSearchVariableSelect">
      <div style={{ display: "flex", alignItems: "center" }}>
        {usage === MULTISEARCH_USAGE.NAVIGATOR_COMPONENT ? (
          <>
            <h4>Unselected variables</h4>
            <CustomTooltip
              type={"select-variable"}
              content={"The variables that are not selected will be ignored"}
            />
          </>
        ) : (
          <h4>Select variables</h4>
        )}
      </div>
      {loading ? (
        <div>Loading variables...</div>
      ) : (
        <React.Fragment>
          <div className="MultiSearchVariableSelect__form">
            <FormControl
              type="text"
              value={searchExpression}
              onChange={changeSearch}
              placeholder="Filter by name or code"
            />
          </div>
          {options.length <= 0 ? (
            <div>There are no variables to select.</div>
          ) : (
            <MultiSearchVariableTree
              model={options}
              onOpenChange={(newExpandedVariables) => {
                setExpandedVariables(() => newExpandedVariables);
              }}
              openItems={expandedVariables}
              searchExpr={searchExpression}
              itemRenderer={(props) => (
                <MultiSearchVariableSelectItem
                  disabled={
                    props?.nodes?.length > 0 &&
                    store.filtersOrder.includes(props.tid)
                  }
                  key={props.value}
                  label={`${props.name} (${props.code})`}
                  maintenanceAgencyId={
                    props.maintenanceAgencyId ||
                    props?.properties?.MAINTENANCE_AGENCY_ID
                  }
                  description={props.description}
                  tid={props.tid}
                  type={props.type}
                  selectedValues={store.filtersOrder}
                  onSelect={store.addFilterItem}
                />
              )}
            />
          )}
        </React.Fragment>
      )}
    </div>
  );
};
